import { forwardRef, PropsWithChildren } from "react";
import MuiBox, { BoxProps as MuiBoxProps } from "@mui/material/Box";

export type BoxProps = MuiBoxProps;

const BoxComponent = forwardRef<HTMLDivElement, PropsWithChildren<BoxProps>>(({ ...props }, ref) => {
  return <MuiBox ref={ref} {...props} />;
});

BoxComponent.displayName = "Box";

const Box = BoxComponent as typeof MuiBox;
export default Box;
